

import React from "react";

import Grid from "@mui/material/Grid";
import {
    AuthBg,
    Left,
    Right,
    Logo,
    Icon1,
    Icon2,
    AuthContent,
    AuthContainer,
} from "./styles";
import useResponsive from "src/components/hooks/useResponsive";
function OnBoardingLayout({ children, ...props }) {
    const { isDesktop } = useResponsive();

    return (

            <Grid container>

                <AuthContainer>
                    <div>{children}</div>
                </AuthContainer>



            </Grid>
    );
}

export default OnBoardingLayout;
